export { HorizontalBarChart } from './HorizontalBarChart';
export { LegendToggleButton } from './components/LegendToggleButton';
export { ValueLabelsToggleButton } from './components/ValueLabelsToggleButton';
export type {
  HorizontalBarChartProps,
  HorizontalBarDatum,
  LegendDisplayMode,
  ValueMode,
} from './types';
